import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useSubscriptionPolling = (options: {
  subscriptionId: string | undefined;
  shouldPoll: boolean;
  currentStatus: string | undefined;
  expectedStatuses?: string[];
  intervalMs?: number;
}) => {
  const queryClient = useQueryClient();
  const { subscriptionId, shouldPoll, currentStatus, expectedStatuses, intervalMs = 2000 } = options;

  useEffect(() => {
    if (!shouldPoll || !subscriptionId) {
      return;
    }

    // Stop polling if status matches one of the expected statuses
    if (expectedStatuses && currentStatus && expectedStatuses.includes(currentStatus)) {
      return;
    }

    const intervalId = setInterval(() => {
      queryClient.invalidateQueries({ queryKey: ['subscription', subscriptionId] });
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [shouldPoll, subscriptionId, currentStatus, expectedStatuses, intervalMs, queryClient]);
};
